import React from "react";
import "./SectionNav.css";

const sections = [
  // { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

const SectionNav = ({ activeSection }) => {
  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="section-nav">
      {sections.map(({ id, label }) => (
        <div
          key={id}
          className={`nav-item ${activeSection === id ? "active" : ""}`}
          onClick={() => handleScroll(id)}
        >
          <span className="line"></span>
          <span className="label">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default SectionNav;
